import i18next from 'i18next'
import ChainedBackend from 'i18next-chained-backend'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { languageDetector, customDetectors } from '@dhl/i18n'
import { dataLayerPublish } from '@dhl/datalayer'

import { localeFilesMap } from './locales'

export const QUERYSTRING_LOCALE = 'locale'

export const LOCAL_STORAGE_LOCALE = 'locale'

// Because i18next does not keep the locales in its own state, we also export
// this function to get the locales in the Language selector
export const locales = (): string[] => ['nl-NL', 'en-NL']

i18next
  .use(languageDetector(locales))
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(ChainedBackend)
  .init({
    backend: {
      backends: [HttpApi],
      backendOptions: [
        {
          loadPath: async (languages: string[], ns: string[]) => {
            if (ns.includes('translation')) {
              const localeFile = await localeFilesMap[languages[0]]

              return localeFile.default
            }
            return undefined
          },
        },
      ],
    },

    ns: ['translation'],
    defaultNS: 'translation',
    saveMissing: true,

    // eslint-disable-next-line @typescript-eslint/naming-convention -- need to ignore these first params
    missingKeyHandler: (_lngs, _ns, key) => {
      dataLayerPublish('ERROR', {
        id: 'i18n',
        message: `i18n - missing '${i18next.language}' translation for key '${key}'`,
      })
    },

    debug: false,

    supportedLngs: locales(),

    detection: {
      order: [customDetectors.queryString, 'localStorage', customDetectors.detectPrimary],
      lookupQuerystring: QUERYSTRING_LOCALE,
      lookupLocalStorage: LOCAL_STORAGE_LOCALE,
    },

    interpolation: {
      escapeValue: false, // react already saves from xss
    },
  })

export const i18n = i18next
